<template>
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2547_55764)">
      <rect
        x="2"
        y="1.49805"
        width="43.0037"
        height="43.0037"
        rx="2.6875"
        fill="#F7F3FF"
      />
      <path
        d="M31.0653 21.3196H15.9453M26.8653 14.5996V17.9596M20.1453 14.5996V17.9596M22.2453 24.6796L23.5053 23.8396V28.0396M22.4553 28.0396H24.5553M19.9773 31.3996H27.0333C28.4447 31.3996 29.1503 31.3996 29.6894 31.1249C30.1636 30.8833 30.549 30.4979 30.7906 30.0237C31.0653 29.4846 31.0653 28.779 31.0653 27.3676V20.3116C31.0653 18.9003 31.0653 18.1946 30.7906 17.6556C30.549 17.1814 30.1636 16.7959 29.6894 16.5543C29.1503 16.2796 28.4447 16.2796 27.0333 16.2796H19.9773C18.566 16.2796 17.8603 16.2796 17.3213 16.5543C16.8471 16.7959 16.4616 17.1814 16.22 17.6556C15.9453 18.1946 15.9453 18.9003 15.9453 20.3116V27.3676C15.9453 28.779 15.9453 29.4846 16.22 30.0237C16.4616 30.4979 16.8471 30.8833 17.3213 31.1249C17.8603 31.3996 18.566 31.3996 19.9773 31.3996Z"
        stroke="#6434D0"
        stroke-width="1.48"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2547_55764"
        x="0.65625"
        y="0.826172"
        width="45.6875"
        height="45.6914"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.671875" />
        <feGaussianBlur stdDeviation="0.671875" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2547_55764"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2547_55764"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
